import{Region as o}from"../types/region.js";var t,i=((t={})[o.DEFAULT]={hutaojie:"//apm.hutaojie.com/web/st.gif",prod:"//st.pinduoduo.com/st.gif"},t);export{i as ReportUrlMap};
